import React from 'react';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function AdminPageHeader({ title, subtitle, actions, badge }) {
  const tc = useThemeClasses();

  return (
    <header className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 pb-1">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <p className={`text-[11px] font-semibold uppercase tracking-wide ${tc.textMuted}`}>
            Administración
          </p>
          {badge ? badge : null}
        </div>
        <h1 className={`text-xl sm:text-2xl font-semibold tracking-tight ${tc.textPri}`}>{title}</h1>
        {subtitle && <p className={`text-sm mt-1 max-w-2xl ${tc.textSec}`}>{subtitle}</p>}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div> : null}
    </header>
  );
}
